<div class="modal-wrapper">
  <img src="../../../assets/icon/agree.png" alt="agree icon" />
  <p *ngIf="role === 'client'">
    {{ "MODALS.WORK_FINISHED.CLIENT" | translate }}
  </p>
  <p *ngIf="role === 'prestataire'">
    {{ "MODALS.WORK_FINISHED.PRESTATAIRE" | translate }}
  </p>
  <p *ngIf="role === 'transporter_demande_sent_success'">
    {{ "TRANSPORTER.COMMON.DEMANDE_SEND_SUCCESS" | translate }}
  </p>
  <p *ngIf="role === 'transporter_demande_pending'">
    {{ "TRANSPORTER.COMMON.DEMANDE_PENDING" | translate }}
  </p>
  <div class="modal-wrapper__buttons">
    <app-button
      (onClick)="closeModal()"
      [innerText]="'MODALS.WORK_FINISHED.CONFIRM' | translate"
    ></app-button>
  </div>
</div>
